/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
import React from 'react';
import { Switch, Route } from 'react-router-dom';
// import React, { useState } from 'react';
// import { Switch, Route, useHistory } from 'react-router-dom';
// import { Spin } from 'antd';
// import Typography from 'antd/lib/typography';
// import Tree, { EventDataNode } from 'antd/lib/tree';
import Layout from 'antd/lib/layout';
// import { ArrowLeftOutlined } from '@ant-design/icons';
// import { useStore } from '../../../store';
// import { ReactComponent as TreeFolder } from '../../../assets/icons/tree_folder.svg';
// import { ReactComponent as DetailsPencil } from '../../../assets/icons/detailsPencil.svg';
import Report from '../../pages/report';
import Reports from '../../pages/reports/reports.page';
// import { useActions } from '../../providers/actions-provider/actions.context';
import { ISidebar } from '../../lib/sidebar/sidebar';
// import { REPORTS_LIST_PATH, EDIT_REPORT_GROUP_PATH } from '../paths.constants';

// const { TreeNode } = Tree;

// const CustomTreeNode = ({
//   title,
//   isFolder,
//   onClick,
// }: {
//   title: string;
//   isFolder: boolean;
//   onClick: () => void;
// }): React.ReactElement => (
//   <div className={`ant-tree-node ${isFolder ? 'ant-tree-node-folder' : ''}`}>
//     <span>{title}</span>
//     <button
//       onClick={(e) => {
//         e.stopPropagation();
//         onClick();
//       }}
//       className="ant-tree-node__btn"
//       type="button"
//     >
//       <DetailsPencil />
//     </button>
//   </div>
// );
const ReportsRouting: React.FC<ISidebar> = ({
  // collapsedBar,
  match,
  // collapseHandler,
}: any) =>
// const { reportsTree } = useStore();
// const { reportActions } = useActions();
// const { push } = useHistory();
// const [expandedKeys, setExpandedKeys] = useState<React.Key[]>([]);
// const [selectedKeys, setSelectedKeys] = useState<React.Key[]>([]);
// function createHierarchyTree(arr: any, nestLvl?: string) {
//   const tree = arr.map((el: any) => {
//     if (el.type === 'report') {
//       return {
//         title: el.name,
//         key: `/exec-${el.id}${nestLvl ? `${nestLvl}` : ''}`,
//       };
//     }
//     if (el.type === 'group' && el.children) {
//       const nest = nestLvl
//         ? `${nestLvl}/${el.name}/${el.id}`
//         : `/${el.name}/${el.id}`;
//       return {
//         title: el.name,
//         key: nest,
//         switcherIcon: <TreeFolder />,
//         children: createHierarchyTree(el.children, nest),
//       };
//     }
//   });
//   return tree;
// }

// const data = createHierarchyTree(reportsTree.data);

// function onSelect(keys: React.Key[], { node }: { node: EventDataNode }) {
//   const path = keys[0]?.toString();
//   const execCheck = path?.includes('exec');
//   if (execCheck) {
//     // find ID for execute report
//     const positionID = path.indexOf('/', 6);
//     if (positionID === -1) {
//       const execID = path.slice(6);
//       reportActions.executeReport(+execID);
//       push(`${REPORTS_LIST_PATH}${keys[0]}`);
//     } else {
//       const execID = path.slice(6, positionID);
//       reportActions.executeReport(+execID);
//     }
//   }

//   if (node.isLeaf) {
//     setSelectedKeys(keys);
//   } else {
//     setExpandedKeys(
//       node.expanded
//         ? expandedKeys.filter((k) => k !== node.key)
//         : expandedKeys.concat(node.key),
//     );
//   }

  //   push(`${REPORTS_LIST_PATH}${keys[0]}`);
  // }
  // eslint-disable-next-line
  (
    <Layout className="main-container">
      <div className="execute-report__container">
        {/* {collapsedBar && reportsTree.data.length && (
          <>
            <div className="report-tree__wrapper">
              <div className="report-tree__header">
                <Typography.Text className="report-tree__title">
                  Reports List
                </Typography.Text>
                <button
                  type="button"
                  onClick={() => collapseHandler(!collapsedBar)}
                >
                  <ArrowLeftOutlined />
                </button>
              </div>
              {data.length ? (
                <Tree
                  showLine={{ showLeafIcon: false }}
                  onSelect={onSelect}
                  expandedKeys={expandedKeys}
                  selectedKeys={selectedKeys}
                  onExpand={(keys) => {
                    setExpandedKeys(keys);
                  }}
                  className="report-tree"
                  height={document.documentElement.clientHeight - 250}
                >
                  {data.map((item: any) => (
                    <TreeNode
                      title={(
                        <CustomTreeNode
                          isFolder={Boolean(item.switcherIcon)}
                          title={item.title}
                          onClick={() =>
                            push(`${REPORTS_LIST_PATH}${item.key}${EDIT_REPORT_GROUP_PATH}`)}
                        />
                      )}
                      key={item.key}
                      isLeaf={item.isLeaf}
                      switcherIcon={item.switcherIcon}
                      // eslint-disable-next-line react/no-children-prop
                      children={
                        item?.children?.length
                          ? item.children.map((child: any) => (
                            <TreeNode
                              title={(
                                <CustomTreeNode
                                  title={child.title}
                                  isFolder={Boolean(child.switcherIcon)}
                                  onClick={() =>
                                push(`${REPORTS_LIST_PATH}${child.key}${EDIT_REPORT_GROUP_PATH}`)}
                                />
                              )}
                              isLeaf={child.isLeaf}
                              switcherIcon={child.switcherIcon}
                              key={child.key}
                            />
                          ))
                          : undefined
                      }
                    />
                  ))}
                </Tree>
              ) : (
                <Spin size="default" style={{ margin: 'auto', alignSelf: 'center' }} />
              )}
            </div>
          </>
        )} */}
        <Switch>
          <Route path={`${match.url}/exec-:id`} render={() => <Report />} />
          <Route path={match.url} render={() => <Reports />} />
        </Switch>
      </div>
    </Layout>
  );
ReportsRouting.displayName = 'ReportsRouting';
export default ReportsRouting;
